import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ROLES } from 'appConstants';
import { syncUserWithMoodle } from 'http/users';

export const useStudentMoodleSync = onSynced => {
  const role = useSelector(state => state.auth.profile?.role);

  useEffect(() => {
    if (role !== ROLES.USER) {
      return;
    }

    syncUserWithMoodle()
      .then(() => {
        if (typeof onSynced === 'function') {
          onSynced();
        }
      })
      .catch(error => {
        console.error('Error syncing with Moodle:', error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);
};
